import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-catalog',
  templateUrl: './profile-catalog.component.html',
  styleUrls: ['./profile-catalog.component.scss']
})
export class ProfileCatalogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
